export default function SystemModalClosingVoid({handleClose}) {
    // Used through the app to display layer aside modals
    // for user to close it

    // BUILD
    return (
        <div className={"cursor-pointer grow h-full"}
             onClick={handleClose}>
        </div>
    );
}